import React, { Component } from 'react';
import { FeatureLeft, FeatureRight } from './Features/index';

class Features extends Component {
    render() {
        return (
        <section className="book-preview section-padding dark-bg-light pb-0"  id="topics">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="section-heading center-heading text-center mb-60">
                         <h3 className="heading-title text-white">Lo que aprenderás</h3>
                         <p className="text-white">
                         Este libro te guiará paso a paso en el desarrollo de tus conocimientos, 
                         ofreciéndote herramientas prácticas y recursos esenciales para 
                         profesionales y emprendedores que buscan crecer y destacar en su campo.
                         </p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <FeatureLeft />
                    </div>

                    <div className="col-lg-6">
                        <FeatureRight />
                    </div>
                </div>
            </div>
        </section> 
        );
    }
}

export default Features;
